import Mock from './mock';
import apolloClient from '../../utils/apollo-client';
import { updateApproval as mutation } from '../graphql/approvals';
import { getEnv } from 'ecx.saigon.ui.common';

export default async function updateApproval(uuid, payLoad) {
  const env = await getEnv();
  if (env.VUE_APP_USE_MOCK) {
    return Mock.data.updateApproval;
  }

  const response = await apolloClient()
    .then((client) =>
      client.mutate({
        mutation,
        variables: {
          uuid,
          payLoad
        }
      })
    );

  return response.data.updateApproval;
}
